import { useState } from "react"
import CadastroMetas from "../../components/CadastroMetas/CadastroMetas"
import NotifierPopup from "../../components/NotifierPopup/NotifierPopup"

function AnimaisCadastroAdm() {
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    })

    return (
        <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <CadastroMetas 
            setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} 
        />
        </>
    )
}

export default AnimaisCadastroAdm